var _defs, _sodipodiNamedview, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 120",
    id: "svg4",
    sodipodiDocname: "discord-mark-white.svg",
    width: 140,
    height: 120,
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview6",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    showgrid: "false"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 114.09784,18.719142 a 105.15,105.15 0 0 0 -26.229993,-8.07 72.06,72.06 0 0 0 -3.36,6.83 97.68,97.68 0 0 0 -29.11,0 72.37,72.37 0 0 0 -3.36,-6.83 105.89,105.89 0 0 0 -26.25,8.09 c -16.6000001,24.56 -21.1000001,48.51 -18.85,72.12 v 0 a 105.73,105.73 0 0 0 32.17,16.149998 77.7,77.7 0 0 0 6.89,-11.109998 68.42,68.42 0 0 1 -10.85,-5.18 c 0.91,-0.66 1.8,-1.34 2.66,-2 a 75.57,75.57 0 0 0 64.320003,0 c 0.87,0.71 1.76,1.39 2.66,2 a 68.68,68.68 0 0 1 -10.870003,5.19 77,77 0 0 0 6.890003,11.099998 105.25,105.25 0 0 0 32.18999,-16.139998 v 0 c 2.64,-27.38 -4.51,-51.11 -18.9,-72.15 z m -65.249993,57.62 c -6.27,0 -11.45,-5.69 -11.45,-12.69 0,-7 5,-12.74 11.43,-12.74 6.43,0 11.57,5.74 11.46,12.74 -0.11,7 -5.05,12.69 -11.44,12.69 z m 42.24,0 c -6.28,0 -11.44,-5.69 -11.44,-12.69 0,-7 5,-12.74 11.44,-12.74 6.44,0 11.540003,5.74 11.430003,12.74 -0.11,7 -5.040003,12.69 -11.430003,12.69 z",
    id: "path2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordMarkWhite);
export default __webpack_public_path__ + "static/media/discord_mark_white.60405534140b955361c6064909f075d4.svg";
export { ForwardRef as ReactComponent };